// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ApiUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.mjs";
import * as AuthVm$PorterinFeature from "../../../view-model/AuthVm.mjs";
import * as AuthStore$PorterinFeature from "../../../domain/store/AuthStore.mjs";
import * as AuthUtils$PorterinFeature from "../../../domain/helpers/AuthUtils.mjs";
import * as NextImage$PorterinFeature from "../../../../../ui/components/NextImage.mjs";
import * as AuthTextCmp$PorterinFeature from "../common/AuthTextCmp.mjs";
import * as CityContext$PorterinFeature from "../../../../../contexts/city-context/CityContext.mjs";
import * as CookieStore$PorterinFeature from "../../../../fare-estimate-v1/utils/browser/CookieStore.mjs";
import * as CookieUtils$PorterinFeature from "../../../../fare-estimate-v1/utils/browser/CookieUtils.mjs";
import * as AuthButtonCmp$PorterinFeature from "../common/AuthButtonCmp.mjs";
import * as AuthContextV1$PorterinFeature from "../../../view-model/contexts/auth-context/AuthContextV1.mjs";
import * as AuthRepoManager$PorterinFeature from "../../../domain/repo/AuthRepoManager.mjs";
import * as ResendOtpOptionVm$PorterinFeature from "../../../view-model/ResendOtpOptionVm.mjs";
import * as ResendOtpModuleScss from "../../styles/ResendOtp.module.scss";
import * as PublishEventsHelper$PorterinFeature from "../../../../../shared/core/helpers/PublishEventsHelper.mjs";
import * as ResendOtpSelectionCardCmp$PorterinFeature from "./ResendOtpSelectionCardCmp.mjs";

var defaultStyles = ResendOtpModuleScss;

function ResendOtpCmp(Props) {
  var set_otp_state = Props.set_otp_state;
  var stylesOpt = Props.styles;
  var is_desktop = Props.is_desktop;
  var close_modal = Props.close_modal;
  var resend_count = Props.resend_count;
  var set_resend_count = Props.set_resend_count;
  var styles = stylesOpt !== undefined ? Caml_option.valFromOption(stylesOpt) : defaultStyles;
  var match = React.useState(function () {
        return /* Init */0;
      });
  var setResenddOtp = match[1];
  var match$1 = React.useState(function () {
        
      });
  var setOption = match$1[1];
  var option = match$1[0];
  var match$2 = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var category = match$2.category;
  var match$3 = AuthContextV1$PorterinFeature.useAuthContext(undefined);
  var user = match$3.user;
  var RepoInstance = AuthRepoManager$PorterinFeature.getAuthRepo(undefined);
  return React.createElement("div", {
              className: styles.wrapper
            }, React.createElement("div", {
                  className: styles["resend-otp-wrapper"]
                }, React.createElement("div", {
                      className: styles.header
                    }, is_desktop ? React.createElement(React.Fragment, undefined, React.createElement("div", {
                                className: styles["back-icon"],
                                onClick: (function (param) {
                                    Curry._1(set_otp_state, (function (param) {
                                            return /* OtpValidation */0;
                                          }));
                                  })
                              }, React.createElement(NextImage$PorterinFeature.make, {
                                    src: AuthVm$PorterinFeature.left_arrow.src,
                                    height: AuthVm$PorterinFeature.left_arrow.height,
                                    width: AuthVm$PorterinFeature.left_arrow.width,
                                    quality: 80.0,
                                    alt: AuthVm$PorterinFeature.left_arrow.alt
                                  })), React.createElement("div", {
                                className: styles.spacing
                              })) : null, React.createElement(AuthTextCmp$PorterinFeature.make, {
                          heading: AuthStore$PorterinFeature.ResendOtp.resend_title,
                          sub_heading: undefined
                        })), React.createElement("div", {
                      className: styles.resend
                    }, ResendOtpOptionVm$PorterinFeature.resend_otp_option.map(function (card_data, index) {
                          return React.createElement(ResendOtpSelectionCardCmp$PorterinFeature.make, {
                                      card_data: card_data,
                                      option: option,
                                      set_option: setOption,
                                      key: String(index)
                                    });
                        }))), React.createElement("div", {
                  className: styles["submit-button"],
                  onClick: (function (param) {
                      var webTrackingId = CookieUtils$PorterinFeature.getCookie(CookieStore$PorterinFeature.web_tracking_id);
                      Curry._1(set_resend_count, (function (param) {
                              return resend_count + 1 | 0;
                            }));
                      PublishEventsHelper$PorterinFeature.publishEvents(category, AuthStore$PorterinFeature.ResendOtp.ga_resend_button + String(resend_count + 1 | 0), undefined);
                      ApiUtils$Catalyst.handleAPIRequest((function (param) {
                              Curry._1(setResenddOtp, (function (param) {
                                      return {
                                              TAG: /* Loading */0,
                                              _0: undefined
                                            };
                                    }));
                              return Curry._3(RepoInstance.resendOtp, webTrackingId, AuthUtils$PorterinFeature.mobile(user), option);
                            }), (function (data) {
                              Curry._1(setResenddOtp, (function (param) {
                                      return {
                                              TAG: /* Live */1,
                                              _0: data
                                            };
                                    }));
                              if (is_desktop) {
                                return Curry._1(set_otp_state, (function (param) {
                                              return /* OtpValidation */0;
                                            }));
                              } else {
                                return Curry._1(close_modal, false);
                              }
                            }), (function (error) {
                              Curry._1(setResenddOtp, (function (param) {
                                      return {
                                              TAG: /* Error */2,
                                              _0: error
                                            };
                                    }));
                            }));
                    })
                }, React.createElement(AuthButtonCmp$PorterinFeature.make, {
                      is_disabled: Belt_Option.isNone(option),
                      is_submitting: match[0] === ({
                          TAG: /* Loading */0,
                          _0: undefined
                        }),
                      class_name: "submit-button",
                      event_name: AuthStore$PorterinFeature.ResendOtp.ga_form_submit_event,
                      category: category,
                      submit_text: AuthStore$PorterinFeature.ResendOtp.resend_button,
                      event_label: option !== undefined && !option ? AuthStore$PorterinFeature.ResendOtp.ga_whatsapp_resend : AuthStore$PorterinFeature.ResendOtp.ga_sms_resend,
                      mobile: AuthUtils$PorterinFeature.mobile(user)
                    })));
}

var make = ResendOtpCmp;

export {
  defaultStyles ,
  make ,
}
/* defaultStyles Not a pure module */
